<template>
  <a-card style="width: 100%">
    <a-table bordered :data-source="dataSource" :columns="columns" :loading="tabLoading">
      <template #operation="{ record }">
        <a-space>
          <a-button size="small" @click="showEdit(record)">编辑</a-button>
        </a-space>
      </template>
    </a-table>
  </a-card>
  <a-modal v-model:visible="visible" title="编辑用户能力" @ok="onSubmit" :afterClose="resetFormState"
    okText="确定" cancelText="取消">
    <a-form :model="formState" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item label="统一用户 ID">
        <a-input v-model:value="formState.authUserId" disabled />
      </a-form-item>
      <a-form-item label="请求次数">
        <a-input-number v-model:value="formState.requestLimit" :min="-1" :precision="0" style="width: 100%;" />
        <div class="hint">-1 表示不限次数，0 表示没有额度</div>
      </a-form-item>
      <a-form-item label="允许 AI 题库">
        <a-switch v-model:checked="formState.allowAi" />
      </a-form-item>
      <a-form-item label="允许付费题库">
        <a-switch v-model:checked="formState.allowPaid" />
      </a-form-item>
    </a-form>

  </a-modal>
</template>

<script>
import { getAppUsers, getUserList, updateUserLimit } from '@/api/TikuComponentApi';
import { message } from 'ant-design-vue';
import { defineComponent, ref, toRaw } from 'vue';
import { hasPermission, PERMISSIONS } from '@/utils/permissions';
import { asArrayResult } from '@/utils/result';
const dataSource = ref([])
const visible = ref(false);
const formState = ref({
  authUserId: '',
  requestLimit: 0,
  allowAi: true,
  allowPaid: true,
})
const tabLoading = ref(true)
const isEdit = ref(false)
const editingId = ref(null)
export default defineComponent({
  name: 'UserList',
  setup() {
    return {
      labelCol: { style: { width: '150px' } },
      wrapperCol: { span: 12 },
      formState,
      visible,
      dataSource,
      tabLoading,
      isEdit,
      columns: [
        {
          title: '用户名',
          dataIndex: 'displayName',
          key: 'displayName',
        },
        {
          title: 'AI 题库',
          dataIndex: 'allowAi',
          key: 'allowAi',
          customRender: ({ text }) => text ? '是' : '否',
        },
        {
          title: '付费题库',
          dataIndex: 'allowPaid',
          key: 'allowPaid',
          customRender: ({ text }) => text ? '是' : '否',
        },
        {
          title: '请求次数',
          dataIndex: 'requestLimit',
          key: 'requestLimit',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          key: 'operation',
          slots: {
            customRender: 'operation',
          },
        },
      ],
    };
  },
  mounted() {
    if (!hasPermission(PERMISSIONS.USER_MANAGE)) {
      message.error('无权限访问用户管理');
      this.$router.push('/adapter/component');
      return;
    }
    this.handleUserList()
  },
  methods: {
    async fetchUserDirectory() {
      const res = await getAppUsers()
      if (res?.status !== 200) {
        return {}
      }
      const items = asArrayResult(res.data)
      return items.reduce((acc, item) => {
        const sub = String(item?.sub || '').trim()
        if (!sub) {
          return acc
        }
        acc[sub] = item?.nickname || item?.username || sub
        return acc
      }, {})
    },
    handleUserList() {
      tabLoading.value = true
      Promise.all([getUserList(), this.fetchUserDirectory()]).then(([res, userMap]) => {
        if (res?.status == 200) {
          dataSource.value = asArrayResult(res?.data).map(item => ({
            ...item,
            displayName: userMap[item.authUserId] || item.authUserId,
          }))
        } else {
          dataSource.value = []
          message.error(res?.message || '加载用户列表失败')
        }
      }).finally(() => {
        tabLoading.value = false
      })
    },
    onSubmit() {
      const payload = { ...toRaw(formState.value) }
      updateUserLimit(editingId.value, {
        requestLimit: payload.requestLimit,
        allowAi: payload.allowAi,
        allowPaid: payload.allowPaid
      }).then(res => {
        if (res.status === 200) {
          message.success('编辑成功')
          this.handleUserList()
          this.resetFormState()
          visible.value = false
        } else {
          message.error(res.message || '编辑失败')
        }
      })
    },
    showEdit(record) {
      isEdit.value = true
      editingId.value = record.id
      formState.value = {
        authUserId: record.authUserId,
        requestLimit: record.requestLimit ?? 0,
        allowAi: record.allowAi !== undefined ? record.allowAi : true,
        allowPaid: record.allowPaid !== undefined ? record.allowPaid : true,
      }
      visible.value = true
    },
    resetFormState() {
      formState.value = {
        authUserId: '',
        requestLimit: 0,
        allowAi: true,
        allowPaid: true,
      };
      isEdit.value = false
      editingId.value = null
    }
  }
});

</script>

<style scoped>
.hint {
  font-size: 12px;
  color: #888;
  margin-top: 4px;
}
</style>
